/**
 * Contract Modalities Catalog Hook
 */

import { useState, useEffect } from 'react';
import { contractCatalogService } from '../contract.service.ts';
import type { ContractModality } from '../contract.types.ts';


interface UseContractModalitiesResult {
  modalities: ContractModality[];
  loading: boolean;
  error: string | null;
}

export function useContractModalities(): UseContractModalitiesResult {
  const [modalities, setModalities] = useState<ContractModality[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    void (async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await contractCatalogService.getModalities();

        if (!isMounted) return;

        if (response.success && response.data) {
          setModalities(response.data);
        } else if (response.error) {
          setError(response.error.description || 'Error loading contract modalities');
        }
      } catch (catchError) {
        if (!isMounted) return;
        setError(catchError instanceof Error ? catchError.message : 'Unknown error');
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, []);

  return { modalities, loading, error };
}
